import React, {useEffect, useRef, useState} from "react";
import {Dropdown} from "primereact/dropdown";
import {
    clearCampaignACD,
    setCampaignTrunkIds,
    setChangedCompaniesData,
    setCompanyField,
    setEditType,
    setTrankId
} from "redux/actions/actions";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {classNames} from "primereact/utils";
import {InputSwitch} from "primereact/inputswitch";
import {MVP} from "../../../redux/config";
import {getUsersManagerUserBranchesData} from "../../../redux/api/apiUsersList";
import {InputNumber} from "primereact/inputnumber";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {checkPermissions} from "../../../redux/permissions/permissionsUtils";
import {getTrunkById} from "../../../redux/api/apiTrunks";
import TrunkListDialog from "../../Settings/TrunksList/TrunkDialog";
import {setTrunkDialogVisible} from "../../../redux/actions/actionsTrunk";
import {
    assignedPhoneIsInactive,
    assignedTrunkIsInactive,
    keepCurrentTrunkSelectable,
    TrunkInactiveIcon,
    TrunkNameField,
    trunkInactiveLabel,
    trunkSelectItemTemplate,
    trunkSelectValueTemplate,
    uniqueTrunkOptions
} from "../../../utils/trunkActivity";

const CompaniesListDialogGeneralSettings = () => {
    const dispatch = useAppDispatch();
    const companiesData = useAppSelector(state => state.CompaniesListReducer.companiesData);
    const errorFields = useAppSelector(state => state.CompaniesListReducer.errorFields);
    const companiesDirectoryCampaignType = useAppSelector(state => state.CompaniesListReducer.companiesDirectoryCampaignType);
    const companiesDirectoryTranksPhones = useAppSelector(state => state.CompaniesListReducer.companiesDirectoryTranksPhones);
    const statusDone = companiesData?.campaign?.statusId === 6;
    const phoneField = useRef(null);
    const nameField = useRef(null);
    const editType = useAppSelector(state => state.UsersReducer.editType);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    // @ts-ignore
    const branches = useAppSelector(state => state.UsersListReducer.branches);
    const archiveTableToggle = useAppSelector(state => state.CompaniesListReducer.archiveTableToggle);
    const companyStateSave = useAppSelector(state => state.CompaniesListReducer.companyStateSave);
    const campaignDetailsLoading = useAppSelector(state => state.CompaniesListReducer.detailsLoading);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const rolePermissions = checkPermissions(rolesVision, 'Trunks');
    const detailsLoading = useAppSelector(state => state.TrunksListReducer.detailsLoading) as unknown as Record<string, string[]>;
    const trunksPairs = useAppSelector(state => state.CompaniesListReducer.trunksPairs);
    const [selectedPairs, setSelectedPairs] = useState<any>([]);
    const [id, setId] = useState<boolean>(false);
    const trunkDialogVisible = useAppSelector(state => state.TrunksListReducer.trunkDialogVisible);

    const {
        visible: hasVisible,
        update: hasUpdatePermission
    } = rolePermissions;
    const scrollIntoNameView = () => {
        // @ts-ignore
        nameField?.current?.scrollIntoView({behavior: 'smooth'});
    }

    useEffect(() => {
        dispatch(setTrunkDialogVisible(false));
    }, []);

    useEffect(() => {
        // @ts-ignore
        const sanitizedPairs = selectedPairs?.map(({trunkId, trunkPhoneId, displayOrder}) => ({
            trunkId,
            trunkPhoneId,
            displayOrder
        }));

        dispatch(setCampaignTrunkIds(sanitizedPairs));
    }, [selectedPairs]);

    const scrollIntoTrankView = () => {
        // @ts-ignore
        phoneField?.current?.scrollIntoView({behavior: 'smooth'});
    }

    useEffect(() => {
        if (!companiesData.campaign.name && errorFields?.name) {
            scrollIntoNameView();
        }
        if (errorFields?.nameUniq) {
            scrollIntoNameView();
        }
        if (errorFields?.trankId && companiesData.campaign.name) {
            scrollIntoTrankView();
        }
    }, [errorFields, companiesData]);

    const branchIsBlock = companiesData?.permission?.branchIsBlock;
    const trunksIsBlock = companiesData?.permission?.trunksIsBlock;
    const isFormEditable = archiveTableToggle && !statusDone && editType;

    const canOpenTrunkDetails = (trunkId: any) =>
        Boolean(
            !trunksIsBlock &&
            hasVisible &&
            trunkId != null &&
            (Array.isArray(companiesDirectoryTranksPhones) ? companiesDirectoryTranksPhones : []).some(
                (item: any) => String(item.sofiaTrunkId ?? item.trunkId) === String(trunkId)
            )
        );

    const trunkDetailsIcon = archiveTableToggle && hasUpdatePermission ? 'pi pi-pencil' : 'pi pi-eye';
    const disabledInputClass = classNames('w-full', {'opacity-100': isFormEditable});

    useEffect(() => {
        if (branchIsBlock) {
            return;
        }
        if (!companyStateSave && campaignDetailsLoading) {
            return;
        }
        dispatch(getUsersManagerUserBranchesData(jwtToken?.jwtToken));
    }, [branchIsBlock, companyStateSave, campaignDetailsLoading, jwtToken?.jwtToken]);

    const campaignTypeItemTemplate = (option: any) => {
        const foundType = companiesDirectoryCampaignType?.find((item: {
            dictionaryId: number
        }) => item.dictionaryId === option);

        if (foundType) {
            return (
                <div className="p-multiselect-representative-option">
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {foundType.name}
                </span>
                </div>
            );
        } else {
            return null;
        }
    };

    const selectedCampaignTypeTemplate = (option: any) => {
        let typeName = companiesDirectoryCampaignType?.map((item: {
            dictionaryId: number;
            name: any;
        }) => {
            if (item.dictionaryId === option) {
                return item.name
            }
        })
        if (option) {
            return (
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {typeName}
                </span>
            );
        }

        return "Оберіть тип";
    }

    const onChangeNameField = (e: any) => {
        dispatch(setCompanyField({section: 'campaign', fieldName: 'campaignName', value: e.target.value}));
    }

    const formattedBranches = branches?.map((branch: {
        id: any;
        name: any;
    }) => ({
        ...branch,
        label: `${branch.id} ${branch.name}`,
    }));

    const displayOrder = (rowData: any) => {
        return <div>{rowData?.displayOrder}</div>
    }

    const updateTrunkName = (displayOrder: any, trunkId: any, trunkIsActive: boolean | null) => {
        setSelectedPairs((currentPairs: any[]) =>
            currentPairs.map(pair =>
                pair.displayOrder === displayOrder
                    ? {...pair, trunkId, trunkPhoneId: null, trunkIsActive, isActive: null}
                    : pair
            )
        );
    };

    const updateTrunkNumber = (displayOrder: any, trunkPhoneId: any, isActive: boolean | null) => {
        setSelectedPairs((currentPairs: any[]) =>
            currentPairs.map(pair =>
                pair.displayOrder === displayOrder ? {...pair, trunkPhoneId, isActive} : pair
            )
        );
    };

    const getTrunkDisplayData = (rowData: any) => {
        if (rowData?.trunkName || rowData?.phoneNo) {
            return rowData;
        }

        return companiesData.trunks?.find((trunk: any) =>
            trunk.displayOrder === rowData?.displayOrder ||
            (trunk.trunkId === rowData?.trunkId && trunk.trunkPhoneId === rowData?.trunkPhoneId)
        ) ?? rowData;
    };

    const trunkName = (rowData: any) => {
        const displayData = getTrunkDisplayData(rowData);
        const gateway = companiesDirectoryTranksPhones?.find(
            (item: any) => item.sofiaTrunkId === rowData?.trunkId
        );

        const trunkInactive = rowData?.trunkIsActive != null
            ? assignedTrunkIsInactive(rowData)
            : assignedTrunkIsInactive(displayData);
        const readOnlyLabel = displayData?.trunkName || gateway?.profileName || rowData?.trunkId || '';

        if (trunksIsBlock || rowData?.saved) {
            return <TrunkNameField value={trunkInactiveLabel(readOnlyLabel)} inactive={trunkInactive} className={disabledInputClass}/>;
        }

        const usedTrunkIdsWithoutPhone = selectedPairs
            .filter((pair: any) => pair.trunkPhoneId === null)
            .map((pair: any) => pair.trunkId);

        const gateways = keepCurrentTrunkSelectable(
            uniqueTrunkOptions(
                (companiesDirectoryTranksPhones || []).filter((item: {sofiaTrunkId: any}) =>
                    !usedTrunkIdsWithoutPhone.includes(item.sofiaTrunkId) ||
                    item.sofiaTrunkId === rowData?.trunkId
                ),
                (item: any) => ({value: item.sofiaTrunkId, label: item.profileName})
            ),
            rowData?.trunkId
        ).map((option) =>
            String(option.value) === String(rowData?.trunkId) && rowData?.trunkIsActive != null
                ? {...option, inactive: rowData.trunkIsActive === false}
                : option
        );

        const hasGatewayError = errorFields?.trankId?.trunkIds?.includes(rowData?.trunkId);

        return <Dropdown
                filter
                disabled={(!archiveTableToggle || !editType)}
                value={rowData?.trunkId} options={gateways}
                optionValue="value"
                optionLabel="label"
                optionDisabled="disabled"
                itemTemplate={trunkSelectItemTemplate}
                valueTemplate={trunkSelectValueTemplate}
                className={classNames('w-full trunk-select', {
                    'p-invalid': hasGatewayError || (errorFields?.userTrunks && !rowData?.trunkId),
                })}
                onChange={(e) => {
                    const selected = gateways.find((item) => item.value === e.value);
                    if (selected?.disabled) {
                        return;
                    }
                    updateTrunkName(rowData?.displayOrder, e.value, selected ? !selected.inactive : null);
                }}
                emptyMessage="Немає доступних"/>
    }

    const trunkNumber = (rowData: any) => {
        const displayData = getTrunkDisplayData(rowData);
        const foundItem = companiesDirectoryTranksPhones?.find(
            (item: {
                id: number
            }) => item.id === rowData?.trunkPhoneId
        );

        if (trunksIsBlock || rowData?.saved) {
            if (!(displayData?.trunkPhoneId || displayData?.phoneNo)) {
                return <div className="opacity-50 italic"></div>;
            }
            const phoneValue = displayData?.phoneNo || foundItem?.phoneNo || '-';
            const phoneInactive = rowData && Object.prototype.hasOwnProperty.call(rowData, 'isActive')
                ? assignedPhoneIsInactive(rowData)
                : assignedPhoneIsInactive(displayData);
            return phoneInactive
                ? <TrunkNameField value={String(phoneValue)} inactive className={disabledInputClass}/>
                : <InputText className={disabledInputClass} disabled value={phoneValue}/>;
        }

        const trunkPhoneIdIds = selectedPairs
            ?.map((pair: {
                trunkPhoneId: any
            }) => pair.trunkPhoneId)
            ?.filter((phoneId: any) => phoneId !== rowData.trunkPhoneId);

        const filteredCompanies = (companiesDirectoryTranksPhones || []).filter(
            (company: {
                id: any;
                sofiaTrunkId: any;
                isReserved: any
            }) =>
                !trunkPhoneIdIds.includes(company.id) &&
                company.sofiaTrunkId === rowData.trunkId &&
                (rowData.trunkType !== 502 || !company.isReserved)
        );

        const phoneShowsInactive = (phone: {id?: any; isActive?: boolean | null} | null) => {
            if (phone && String(phone.id) === String(rowData?.trunkPhoneId) && rowData?.isActive != null) {
                return rowData.isActive === false;
            }
            return assignedPhoneIsInactive(phone);
        };

        return (
            <Dropdown
                filter
                value={rowData?.trunkPhoneId}
                options={filteredCompanies}
                optionValue="id"
                optionLabel="phoneNo"
                onChange={(e) => {
                    const phone = filteredCompanies.find((item: {id: any}) => item.id === e.value) as {isActive?: boolean | null} | undefined;
                    updateTrunkNumber(rowData?.displayOrder, e.value, e.value == null ? null : phone?.isActive ?? null);
                }}
                itemTemplate={(phone: {id?: any; phoneNo?: string; isActive?: boolean | null}) => (
                    <span className="flex align-items-center justify-content-between gap-2 w-full">
                        <span>{phone?.phoneNo}</span>
                        {phoneShowsInactive(phone) ? <TrunkInactiveIcon/> : null}
                    </span>
                )}
                valueTemplate={(phone: {id?: any; phoneNo?: string; isActive?: boolean | null} | null, props: {placeholder?: string}) => (
                    <span className="trunk-select-value">
                        <span>{phone?.phoneNo || props?.placeholder || "\u00a0"}</span>
                        {phoneShowsInactive(phone) ? <TrunkInactiveIcon/> : null}
                    </span>
                )}
                className={classNames('w-full trunk-select', {
                    'p-invalid': errorFields?.userTrunks && !rowData?.trunkPhoneId
                })}
                emptyMessage="Немає доступних"
                disabled={!rowData.trunkId || !archiveTableToggle || !editType}
            />
        );
    };

    const addPair = (trunkId: null, trunkPhoneId: null, order?: null, saved = false) => {
        setSelectedPairs((prevPairs: any[]) => {
            if (trunkId != null && trunkPhoneId != null) {
                const pairExists = prevPairs.some(pair => pair.trunkId === trunkId && pair.trunkPhoneId === trunkPhoneId);
                if (pairExists) {
                    return prevPairs;
                }
            }

            const newPair = {trunkId, trunkPhoneId, displayOrder: prevPairs.length + 1, saved};
            const newPairs = [...prevPairs, newPair];

            return newPairs.map((pair, index) => ({
                ...pair,
                displayOrder: index + 1
            }));
        });
    };

    const deleteTrunk = (rowData: any) => {
        if (trunksIsBlock) {
            return null;
        }
        return <div>
            {selectedPairs?.length > 1 && <div>
                <Button icon="pi pi-times" className="p-button-secondary"
                        disabled={(!archiveTableToggle || !editType)}
                        onClick={() => removePair(rowData.displayOrder)}/>

            </div>}
        </div>
    }

    const showTrunkDetails = (rowData: any) => {
        if (!canOpenTrunkDetails(rowData?.trunkId)) {
            return null;
        }
        const isLoading = id === rowData.trunkId && Boolean(detailsLoading);
        const isDisabled = Boolean(id) && Boolean(detailsLoading);

        return <Button
            disabled={isDisabled}
            loading={isLoading}
            onClick={() => {
                openEditor(rowData?.trunkId);
                setId(rowData?.trunkId);
            }}
            icon={trunkDetailsIcon}
            style={{minHeight: '30px', minWidth: '30px', maxWidth: '37px'}}
            className={classNames(
                'p-button-secondary cursor-card-item flex align-items-center justify-content-center'
            )}
        />
    };

    useEffect(() => {
        if (companiesData.trunks?.length) {
            const newPairs = companiesData.trunks
                .map((queueTrunk: any) => {
                    const trunkPhone = companiesDirectoryTranksPhones?.find(
                        (item: {
                            id: any;
                        }) => item.id === queueTrunk.trunkPhoneId
                    );

                    return {
                        trunkId: queueTrunk.trunkId ?? null,
                        trunkPhoneId: trunkPhone?.id ?? queueTrunk.trunkPhoneId ?? null,
                        trunkName: queueTrunk.trunkName,
                        phoneNo: queueTrunk.phoneNo,
                        isActive: queueTrunk.isActive ?? null,
                        trunkIsActive: queueTrunk.trunkIsActive,
                        displayOrder: queueTrunk.displayOrder || 1,
                        saved: true
                    };
                })
                .sort((a: {
                    displayOrder: number;
                }, b: {
                    displayOrder: number;
                }) => a.displayOrder - b.displayOrder);

            setSelectedPairs(newPairs);
        } else if (companiesData.trunks?.length === 0 && selectedPairs.length === 0) {
            setSelectedPairs([]);
        }
    }, [companiesData.trunks, companiesDirectoryTranksPhones]);

    useEffect(() => {
        if (trunksPairs?.length > 0 && selectedPairs.length === 0) {
            setSelectedPairs(trunksPairs.map((pair: any, index: number) => {
                const sourceTrunk = companiesData.trunks?.find((trunk: any) =>
                    trunk.displayOrder === pair.displayOrder ||
                    (trunk.trunkId === pair.trunkId && trunk.trunkPhoneId === pair.trunkPhoneId)
                ) ?? companiesData.trunks?.[index];

                return {
                    ...pair,
                    trunkName: sourceTrunk?.trunkName,
                    phoneNo: sourceTrunk?.phoneNo,
                    isActive: sourceTrunk?.isActive ?? pair.isActive ?? null,
                    trunkIsActive: sourceTrunk?.trunkIsActive ?? pair.trunkIsActive,
                    saved: pair.saved ?? true,
                };
            }));
        }
    }, [trunksPairs, companiesData.trunks]);

    const removePair = (displayOrder: any) => {
        setSelectedPairs((prevPairs: any[]) =>
            prevPairs
                .filter((pair: {
                    displayOrder: any;
                }) => pair.displayOrder !== displayOrder) // Удаление элемента
                .map((pair: any, index: number) => ({...pair, displayOrder: index + 1})) // Обновление displayOrder
        );
    };

    const onRowReorder = (e: {
        dragIndex: number;
        dropIndex: number;
    }) => {
        let updatedRows = [...selectedPairs];
        const draggedRow = updatedRows[e.dragIndex];

        updatedRows.splice(e.dragIndex, 1);

        updatedRows.splice(e.dropIndex, 0, draggedRow);

        updatedRows = updatedRows.map((row, index) => ({
            ...row,
            displayOrder: index + 1
        }));
        setSelectedPairs(updatedRows)
    };

    const openEditor = (id: number) => {
        dispatch(getTrunkById(id, jwtToken?.jwtToken));
        dispatch(setTrunkDialogVisible(true));

        if (hasUpdatePermission) {
            dispatch(setEditType(true));
        } else {
            dispatch(setEditType(false));
        }
    };

    return (
        <div className="general-settings">
            {trunkDialogVisible && <TrunkListDialog/>}
            <div className="grid p-fluid">
                <div className="field col-12 md:col-6" ref={nameField}>
                    <label htmlFor="name"
                           className={classNames('', {'p-error': errorFields?.name || errorFields?.nameUniq})}>Назва
                        кампанії *</label>
                    <InputText
                        id="name"
                        value={companiesData?.campaign?.campaignName || ''}
                        maxLength={150}
                        className={classNames('', {'p-invalid': errorFields?.name || errorFields?.nameUniq})}
                        onChange={e => {
                            onChangeNameField(e);
                            dispatch(setChangedCompaniesData(true))
                        }}
                        disabled={!archiveTableToggle || statusDone || !editType}
                    />
                    {errorFields?.nameUniq && <div className="col-12 md:col-12 pt-2 px-0 pb-0"><span
                        className="title p-error text-sm">{errorFields?.nameUniq}*</span></div>}
                </div>
                <div className="field col-12 md:col-6"></div>
                <div className="field col-12 md:col-6">
                    <label htmlFor="description">Коментар</label>
                    <InputTextarea
                        id="description"
                        value={companiesData?.campaign?.description || ''}
                        onChange={e => {
                            dispatch(setChangedCompaniesData(true));
                            dispatch(setCompanyField({section: 'campaign', fieldName: 'description', value: e.target.value}))
                        }}
                        autoResize
                        rows={3}
                        maxLength={500}
                        disabled={!archiveTableToggle || statusDone || !editType}
                    />
                </div>
                <div className="field col-12 md:col-6"></div>
                <div className="field col-12 md:col-6">
                    <label htmlFor="type">Оберіть тип</label>
                    {MVP ?
                        <Dropdown id="type"
                                  appendTo="self"
                                  filter
                                  value={companiesData.campaign.campaignTypeId || ''}
                                  options={companiesDirectoryCampaignType}
                                  onChange={e => {
                                      dispatch(setCompanyField({section: 'campaign', fieldName: 'campaignTypeId', value: e.target.value}));
                                      dispatch(setChangedCompaniesData(true));
                                      dispatch(setCompanyField({section: 'campaign', fieldName: 'isGeneralUser', value: true}));
                                      if (e.target.value === 201) {
                                          dispatch(clearCampaignACD());
                                      }
                                      if (e.target.value === 202) {
                                          dispatch(setCompanyField({section: 'campaign', fieldName: 'firstCallOperator', value: false}));
                                          dispatch(setCompanyField({section: 'campaign', fieldName: 'isGeneralTrunk', value: true}));
                                          dispatch(setCompanyField({section: 'campaign', fieldName: 'isInLineCountCalls', value: true}));
                                          dispatch(setCompanyField({section: 'campaignACD', fieldName: 'isIVMAudio', value: true}));
                                      }
                                      if (e.target.value === 204) {
                                          dispatch(clearCampaignACD());
                                          dispatch(setCompanyField({section: 'campaign', fieldName: 'firstCallOperator', value: false}));
                                          dispatch(setCompanyField({section: 'campaign', fieldName: 'isGeneralTrunk', value: true}));
                                          dispatch(setCompanyField({section: 'campaignACD', fieldName: 'isIVMAudio', value: true}));
                                          dispatch(setCompanyField({section: 'campaignACD', fieldName: 'audioRetries', value: 1}));
                                          dispatch(setCompanyField({section: 'campaign', fieldName: 'isInLineCountCalls', value: true}));
                                      }
                                      if (e.target.value === 205) {
                                          dispatch(clearCampaignACD());
                                          dispatch(setCompanyField({section: 'campaign', fieldName: 'isGeneralUser', value: false}));
                                      }
                                  }}
                                  optionValue='dictionaryId'
                                  optionLabel='name'
                                  disabled={!archiveTableToggle || statusDone || !editType}
                                  placeholder="Оберіть тип"
                        /> :
                        <Dropdown id="type"
                                  appendTo="self"
                                  filter
                                  value={companiesData.campaign.campaignTypeId || ''}
                                  options={companiesDirectoryCampaignType.map((item: {
                                      dictionaryId: number;
                                  }) => item.dictionaryId)}
                                  onChange={e => {
                                      dispatch(setCompanyField({section: 'campaign', fieldName: 'campaignTypeId', value: e.target.value}));
                                      dispatch(setChangedCompaniesData(true))
                                      dispatch(setCompanyField({section: 'campaignACD', fieldName: 'isIVMAudio', value: false}));
                                  }}
                                  itemTemplate={campaignTypeItemTemplate}
                                  valueTemplate={selectedCampaignTypeTemplate}
                                  disabled={!archiveTableToggle || statusDone || !editType}
                                  placeholder="Оберіть тип"
                        />}
                </div>
                <div className="field col-12 md:col-4"></div>
                <div className="field col-12 md:col-4">
                    <label htmlFor="name"
                           className={classNames('', {'p-error': errorFields?.branchId && !companiesData.campaign?.branchId})}>Бранч
                        *</label>
                    {branchIsBlock ? (
                        <InputText
                            className={disabledInputClass}
                            disabled
                            value={companiesData?.campaign?.branchName || ''}
                        />
                    ) : (
                        <Dropdown
                            id="role"
                            value={companiesData.campaign?.branchId || ''}
                            options={formattedBranches}
                            filter
                            className={classNames('w-full', {'p-invalid': errorFields?.branchId && !companiesData.campaign?.branchId})}
                            optionValue="id"
                            optionLabel="label"
                            placeholder='Виберіть бранч'
                            onChange={e => {
                                dispatch(setCompanyField({section: 'campaign', fieldName: 'branchId', value: e.target.value}));
                            }}
                            disabled={!archiveTableToggle || statusDone || !editType}
                        />
                    )}
                </div>
                <div className="p-divider p-component p-divider-horizontal p-divider-solid p-divider-left"></div>
                {(companiesData.campaign.campaignTypeId === 202 || companiesData.campaign.campaignTypeId === 204 || companiesData.campaign.campaignTypeId === 205) &&
                    <div className="field col-12 md:col-12 mb-0"><label htmlFor="name" className="mr-2">Одночасних викликів</label></div>}
                {(companiesData.campaign.campaignTypeId === 202 || companiesData.campaign.campaignTypeId === 204 || companiesData.campaign.campaignTypeId === 205) &&
                    <div className="field col-12 md:col-12 field-radiobutton pl-2 mb-0">
                        <label htmlFor="icon" className="mr-2">Розрахункова кількість EWT</label>
                        <InputSwitch disabled checked={companiesData.campaign.isInLineCountCalls} onChange={(e) => {
                            dispatch(setCompanyField({section: 'campaign', fieldName: 'isInLineCountCalls', value: e.value}));
                            dispatch(setChangedCompaniesData(true))
                        }}/>
                        <label htmlFor="name" className="mr-2">Задана кількість</label>
                    </div>}
                {(companiesData.campaign.campaignTypeId === 202 || companiesData.campaign.campaignTypeId === 204 || companiesData.campaign.campaignTypeId === 205) && companiesData.campaign.isInLineCountCalls &&
                    <div className="field col-12 md:col-4 m-0">
                        <InputNumber
                            className={classNames('max-w-4rem', {'p-invalid': errorFields?.inLineCountCalls})}
                            disabled={!archiveTableToggle || statusDone || !editType}
                            value={companiesData.campaign.inLineCountCalls || null} onChange={(e) => {
                            dispatch(setCompanyField({section: 'campaign', fieldName: 'inLineCountCalls', value: e.value}));
                            dispatch(setChangedCompaniesData(true))
                        }}/>
                    </div>}
                {errorFields?.inLineCountCalls && <div className="col-12 md:col-12 pt-2 px-0 pb-0"><span
                    className="title p-error text-sm">{errorFields?.inLineCountCalls?.name}*</span></div>}
                <div className="col-12 md:col-12 pt-2 px-0 pb-0"></div>
                {companiesData.campaign.campaignTypeId === 205 && <div className="p-divider p-component p-divider-horizontal p-divider-solid p-divider-left"></div>}
                {companiesData.campaign.campaignTypeId === 205 && <div className="col-12 md:col-3">
                    <label htmlFor="name" className="font-bold">Липка кампанія</label>
                    <div className="field-radiobutton mt-4 mb-3">
                        <label htmlFor="name" className="mr-2 ml-0">Не активний</label>
                        <InputSwitch
                            disabled={!archiveTableToggle || statusDone || !editType}
                            checked={companiesData.campaign.isGeneralUser} onChange={(e) => {
                            dispatch(setCompanyField({section: 'campaign', fieldName: 'isGeneralUser', value: e.value}));
                            dispatch(setChangedCompaniesData(true));
                            if (!e.value) {
                                dispatch(setCompanyField({section: 'campaign', fieldName: 'isGeneralTrunk', value: true}));
                            }
                        }}/>
                        <label htmlFor="icon">Активний</label>
                    </div>
                </div>}
                <div className="col-12 md:col-4">
                    <label htmlFor="name" className="font-bold">Дозвон до клієнта</label>
                    <div className="field-radiobutton mt-4 mb-1">
                        <label htmlFor="name" className="mr-2 ml-0">timeout (сек.)</label>
                        <InputNumber
                                     value={companiesData.campaign?.timeoutExternalOnAnswer || ''}
                                     disabled={!archiveTableToggle || statusDone || !editType}
                                     onChange={(e) => {
                                         dispatch(setCompanyField({section: 'campaign', fieldName: 'timeoutExternalOnAnswer', value: e.value}));
                                         dispatch(setChangedCompaniesData(true))
                                     }}
                                     className={classNames('max-w-4rem', {'p-invalid': errorFields?.timeoutExternalOnAnswer && !companiesData.campaign?.timeoutExternalOnAnswer})}
                        />
                    </div>
                    {errorFields?.timeoutExternalOnAnswer && <div className="col-12 md:col-12 pt-2 px-0 pb-0"><span
                        className="title p-error text-sm">{errorFields?.timeoutExternalOnAnswer?.timeoutExternalOnAnswer}</span></div>}
                </div>
                <div className="p-divider p-component p-divider-horizontal p-divider-solid p-divider-left"></div>
                {/*<div className="field col-12 md:col-4">*/}
                {/*    <label htmlFor="name"*/}
                {/*           className={classNames('', {'p-error': errorFields?.branchId && !companiesData.campaign?.branchId})}>Бранч*/}
                {/*        *</label>*/}
                {/*    <Dropdown*/}
                {/*        id="role"*/}
                {/*        value={companiesData.campaign?.branchId || ''}*/}
                {/*        options={formattedBranches}*/}
                {/*        filter*/}
                {/*        className={classNames('w-full', {'p-invalid': errorFields?.branchId && !companiesData.campaign?.branchId})}*/}
                {/*        optionValue="id"*/}
                {/*        optionLabel="label"*/}
                {/*        placeholder='Виберіть бранч'*/}
                {/*        onChange={e => {*/}
                {/*            dispatch(setCompanyField({section: 'campaign', fieldName: 'branchId', value: e.target.value}));*/}
                {/*        }}*/}
                {/*        disabled={!archiveTableToggle || statusDone || !editType}*/}
                {/*    />*/}
                {/*</div>*/}
                {/*<div className="p-divider p-component p-divider-horizontal p-divider-solid p-divider-left"></div>*/}

            </div>
            {companiesData?.campaign?.campaignTypeId && <div>
                <div>
                    <label htmlFor="name" className="font-bold text-base">Налаштування стратегії</label>
                </div>
                <div className="p-divider p-component p-divider-horizontal p-divider-solid p-divider-left"></div>
                <div>
                    {companiesData?.campaign?.campaignTypeId !== 205 && <div>
                        <label htmlFor="name">Напрямок дзвінків</label>
                        <div className="field-radiobutton my-4 pl-2">
                            <label htmlFor="name" className="mr-2">На клієнта</label>
                            <InputSwitch
                                disabled={!archiveTableToggle || statusDone || !editType || companiesData.campaign.campaignTypeId === 204 || companiesData.campaign.campaignTypeId === 202}
                                checked={companiesData.campaign.firstCallOperator} onChange={(e) => {
                                dispatch(setCompanyField({section: 'campaign', fieldName: 'firstCallOperator', value: e.value}));
                                dispatch(setChangedCompaniesData(true))
                            }}/>
                            <label htmlFor="icon">На оператора</label>
                        </div>
                    </div>}
                    <div className="flex flex-wrap align-items-center">
                        <div className="col-12 md:col-4">
                            <label htmlFor="name" className="font-bold">Транк</label>
                            <div className="field-radiobutton my-4">
                                <label htmlFor="name" className="mr-2 ml-0">Транк Оператора</label>
                                {companiesData?.campaign?.campaignTypeId === 205 ?<InputSwitch
                                    disabled={!companiesData?.campaign?.isGeneralUser || !archiveTableToggle || statusDone || !editType || companiesData.campaign.campaignTypeId === 204 || companiesData.campaign.campaignTypeId === 202}
                                    checked={companiesData.campaign.isGeneralTrunk} onChange={(e) => {
                                    dispatch(setCompanyField({section: 'campaign', fieldName: 'isGeneralTrunk', value: e.value}));
                                    dispatch(setChangedCompaniesData(true))
                                    if (!e.value) {
                                        dispatch(setCompanyField({section: 'campaign', fieldName: 'isRevolver', value: false}));
                                    }
                                }}/> :
                                <InputSwitch
                                    disabled={!archiveTableToggle || statusDone || !editType || companiesData.campaign.campaignTypeId === 204 || companiesData.campaign.campaignTypeId === 202}
                                    checked={companiesData.campaign.isGeneralTrunk} onChange={(e) => {
                                    dispatch(setCompanyField({section: 'campaign', fieldName: 'isGeneralTrunk', value: e.value}));
                                    dispatch(setChangedCompaniesData(true))
                                    if (!e.value) {
                                        dispatch(setCompanyField({section: 'campaign', fieldName: 'isRevolver', value: false}));
                                    }
                                }}/>}
                                <label htmlFor="icon">Загальний транк кампанії</label>
                            </div>
                        </div>
                        <div className="col-12 md:col-3">
                            <label htmlFor="name" className="font-bold">Revolver</label>
                            <div className="field-radiobutton my-4">
                                <label htmlFor="name" className="mr-2 ml-0">Не активний</label>
                                <InputSwitch
                                    disabled={!archiveTableToggle || statusDone || !editType || !companiesData.campaign?.isGeneralTrunk}
                                    checked={companiesData.campaign.isRevolver} onChange={(e) => {
                                    dispatch(setCompanyField({section: 'campaign', fieldName: 'isRevolver', value: e.value}));
                                    dispatch(setChangedCompaniesData(true))
                                }}/>
                                <label htmlFor="icon">Активний</label>
                            </div>
                        </div>
                    </div>
                    {companiesData.campaign?.isGeneralTrunk && <div className="grid p-fluid">
                        <div className="grid p-fluid">
                            <div className="col-12 md:col-12">
                                <DataTable
                                    value={selectedPairs}
                                    emptyMessage={<></>}
                                    reorderableColumns
                                    reorderableRows={!trunksIsBlock}
                                    rowClassName={(rowData) => {
                                        const invalidTrunks = errorFields?.trankId?.trunkIds;
                                        return Array.isArray(invalidTrunks) && invalidTrunks.includes(rowData.trunkId)
                                            ? 'p-invalid'
                                            : '';
                                    }}
                                    onRowReorder={onRowReorder}
                                    className="w-full">
                                    {!trunksIsBlock && <Column rowReorder style={{width: '3rem'}}/>}
                                    <Column body={displayOrder} style={{width: '2rem'}}/>
                                    <Column body={trunkName} style={{width: '15rem'}}/>
                                    <Column body={trunkNumber} style={{width: '15rem'}}/>
                                    {!trunksIsBlock && <Column body={showTrunkDetails} style={{width: '40px'}}/>}
                                    {!trunksIsBlock && <Column body={deleteTrunk} style={{width: '1rem', paddingLeft: 0}}/>}
                                </DataTable>
                            </div>
                        </div>
                        <div className="col-12 md:col-12">
                            {errorFields?.trankId?.campaignTranks && (
                                <div className="title p-error text-sm">
                                    {errorFields.trankId.campaignTranks}*
                                </div>
                            )}
                        </div>
                        {!trunksIsBlock && <div className="field col-12 md:col-12" style={{maxWidth: '150px'}}>
                            <Button disabled={(!archiveTableToggle || (!editType))} icon="pi pi-plus"
                                    onClick={() => addPair(null, null, null)}><label className="pl-2">Додати
                                транк</label></Button>
                        </div>}
                    </div>}
                </div>
            </div>}
        </div>
    )
}

export default CompaniesListDialogGeneralSettings
